import img1 from '../images/1.png'
import imga1 from '../images/avatar/avt.svg'
import img2 from '../images/2.png'
import imga2 from '../images/avatar/avt.svg'
import img3 from '../images/3.png'
import imga3 from '../images/avatar/avt.svg'
import img4 from '../images/4.png'
import imga4 from '../images/avatar/avt.svg'
import img5 from '../images/5.png'
import imga5 from '../images/avatar/avt.svg'
import img6 from '../images/6.png'
import imga6 from '../images/avatar/avt.svg'
import img7 from '../images/7.png'
import imga7 from '../images/avatar/avt.svg'
import img8 from '../images/8.png'
import imga8 from '../images/avatar/avt.svg'
import imgCollection1 from '../images/avatar/avt.svg'


const todayPickData = [
    {
        img: img1,
        title: "The RenaiXance Rising the sun ",
        tags: "MATIC",
        imgAuthor: imga1,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img2,
        title: "Space babe - Night 2/25 ",
        tags: "MATIC",
        imgAuthor: imga2,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        feature: "coming soon",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D",
    },
    {
        img: img3,
        title: "CyberPrimal 042 LAN",
        tags: "MATIC",
        imgAuthor: imga3,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img4,
        title: "Crypto Egg Stamp #5 ",
        tags: "MATIC",
        imgAuthor: imga4,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img5,
        title: "Travel Monkey Club #45 ",
        tags: "MATIC",
        imgAuthor: imga5,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img6,
        title: "Sir. Lion Swag #371 ",
        tags: "MATIC",
        imgAuthor: imga6,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img7,
        title: "Cyber Doberman #766",
        tags: "MATIC",
        imgAuthor: imga7,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img8,
        title: "Living Vase 01 by Lanz...",
        tags: "MATIC",
        imgAuthor: imga8,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img1,
        title: "The RenaiXance Rising the sun ",
        tags: "MATIC",
        imgAuthor: imga1,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img2,
        title: "Space babe - Night 2/25 ",
        tags: "MATIC",
        imgAuthor: imga2,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        feature: "coming soon",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img3,
        title: "CyberPrimal 042 LAN",
        tags: "MATIC",
        imgAuthor: imga3,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img4,
        title: "Crypto Egg Stamp #5 ",
        tags: "MATIC",
        imgAuthor: imga4,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img5,
        title: "Travel Monkey Club #45 ",
        tags: "MATIC",
        imgAuthor: imga5,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img6,
        title: "Sir. Lion Swag #371 ",
        tags: "MATIC",
        imgAuthor: imga6,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img7,
        title: "Cyber Doberman #766",
        tags: "MATIC",
        imgAuthor: imga7,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    },
    {
        img: img8,
        title: "Living Vase 01 by Lanz...",
        tags: "MATIC",
        imgAuthor: imga8,
        nameAuthor: "Ursi",
        price: "100 MATIC",
        priceChange: "$12.246",
        wishlist: "100",
        imgCollection: imgCollection1,
        nameCollection: "Creative Art 3D"
    }

]

export default todayPickData;